import React, { Component } from 'react';

import './Advantage.css';

import bag from './imgs/icon_bag_line.svg';
import card from './imgs/icon_card_fill.svg';
import phone from './imgs/icon_phone_line.svg';

import car from './imgs/icon3.svg';
import cloth from './imgs/icon2.svg';

var moreShoppingDesc=
    'QbatesApp is glad to give ALL of the store’s commission back to you. We’ll deduct only $1 from your reward ' +
    'if and only if you earn more than $10 for any given month to sustain the product. More shopping, More Earning is our mantra!';

var oneStopShoppingDesc=
    'QbatesApp focuses on product aggregation and recommendations. Search and browse all products at a single location. -Qbates ' +
    'mobile application - without having to sift through hundreds of websites to find what you truly want. QbatesApp gives you ' +
    'nothing but the best price and best cashback offer. We thrive on our commitment to help you save time and money.';

class Advantage extends Component {
  render() {
    return (
      <div className="Advantage">
        <h2>Why QbatesApp</h2>
        <div className="Illustration" />
        <div className="Intros">
          <div className="Left">
            <div className="back">
              <div className="title">
                <img src={cloth} alt="cashback"/>
                <h3 className="shopping">MORE SHOPPING MORE EARNING</h3>
              </div>
              <p className="text"> {moreShoppingDesc} </p>
            </div>
          </div>
          <div className="Right">
            <div className="products">
              <div className="title">
                <img src={car} alt="products"/>
                <h3 className="oneStop">ONE-STOP SHOPPING</h3>
              </div>
              <p className="text"> {oneStopShoppingDesc} </p>
            </div>
          </div>
        </div>
        <div className="Items">
          <div className="Item">
            <img className="bag" src={bag} alt="Earn by shopping"/>
            <div>
              <h5>EARN BY SHOPPING</h5>
              <p>More Shopping, More Earning. Enjoy shopping on Qbates apps.</p>
            </div>
          </div>
          <div className="Item">
            <img className="phone" src={phone} alt="Mobile support"/>
            <div>
              <h5>MOBILE SUPPORT</h5>
              <p>Shopping is in your hands, literally! Supports both iOS and Android.</p>
            </div>
          </div>
          <div className="Item">
            <img className="card" src={card} alt="Easy cashback"/>
            <div>
              <h5>EASY CASHBACK</h5>
              <p>We will send your reward to your PayPal account on a monthly basis</p>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Advantage;


// WEBPACK FOOTER //
// ./src/Containers/Home/components/Advantage.js